import { TABLA_CAMIONES_ENTRE_BRUTO_Y_DESTARE } from '../../../../../../config/tables'
import { getColumnasCamionesBrutoYDestare } from './constantesCamionesEntreBrutoYDestare'
import { TablaCamionesEntreBrutoYDestareService } from '../servicio/tabla_camiones_entre_bruto_y_destare'

export function actualizarDatosParaMuiTable (rol = null, filtroInicial = null) {
  return dispatch => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLA_CAMIONES_ENTRE_BRUTO_Y_DESTARE
    })
    TablaCamionesEntreBrutoYDestareService.getDataCamionesEntreBrutoYDestare().then(callback)
    function callback (data) {
      const textRowCount = 'Cantidad de camiones: '
      const columnas = getColumnasCamionesBrutoYDestare(rol)
      dispatch({
        type: 'UPDATE_MUITABLE',
        newState: {
          columns: columnas,
          data: data,
          title: `Camiones entre bruto y destare`,
          isLoading: false,
          fixed2Decimales: false,
          extraOptions: {
            print: false,
            pagination: false,
            tableBodyMaxHeight: '599px',
            showRowCount: true,
            textRowCount,
            filtroInicial: filtroInicial
          }
        },
        id: TABLA_CAMIONES_ENTRE_BRUTO_Y_DESTARE
      })
    }
  }
}
